





































import { Component, Vue, Watch } from 'vue-property-decorator';
import VueBetterScroll from 'vue2-better-scroll';
import { hideLoading, showLoading } from '@tencent/wphk-components-loading';
import { showBusinessError } from '@tencent/wphk-components-dialog';
import { CustomException } from '@tencent/ppd-base-libs';
import { biHT } from '@/business/bi';
import { Route } from 'vue-router';
import InvalidEntry from '../../components/voucher/invalid-entry.vue';
import { i18n } from '../../i18n/index';
import { FitLayout, FitWxPhonex } from '@tencent/wphk-ui';
import to from '@/business/to.js';
import { VoucherItem, EntryEnum } from '@/types/voucher';
import Voucher from '@/components/voucher/voucher.vue';
import { getAllVoucherList, fetchExpiredList, sortExpiredList, sortVoucherList, setCardCache, isValid } from '@/business/voucher';
@Component({
  components: {
    Voucher,
    VueBetterScroll,
    InvalidEntry,
    FitLayout,
    FitWxPhonex,
  },
})
export default class VoucherList extends Vue {
  /** 消费券券数据 */
  private voucherList: VoucherItem[] = [];
  private isPageReady = false;
  /** 是否展示券列表 */
  private get isEmpty() {
    return this.voucherList.length === 0;
  }

  private get isInvalidCouponPage() {
    return this.$route.query.type === EntryEnum.INVALID;
  }
  @Watch('$route', { immediate: true })
  private async handleRouteChange(to: Route, from: Route) {
    if (from && from.path === '/voucherlist') {
      this.isPageReady = false;
      this.voucherList = [];
      this.setTitleAndHottag();
      await this.initPage();
    }
  }

  private async created() {
    this.setTitleAndHottag();
    this.initPage();
  }

  private async initPage() {
    if (this.isInvalidCouponPage) {
      await this.fetchInvalidCouponList();
    } else {
      await this.fetchCouponList();
    }

    this.isPageReady = true;
  }

  private setTitleAndHottag() {
    document.title = this.isInvalidCouponPage
      ? i18n('已用及失效卡券')
      : i18n('消费券');
    this.isInvalidCouponPage
      ? biHT('wallet.cvlist.expiredpage.brow')
      : biHT('wallet.cvlist.listpage.brow');
  }

  private async fetchCouponList() {
    showLoading();
    const [err, res] = await to(getAllVoucherList());
    hideLoading();
    if (err) {
      showBusinessError(err);
      throw new CustomException(err, '获取未过期的消费券列表失败');
    }
    this.voucherList = sortVoucherList(res).filter(item => isValid(item.validTime));
    console.log(this.voucherList);
  }
  private async fetchInvalidCouponList() {
    showLoading();
    const [err, res] = await to(fetchExpiredList());
    hideLoading();
    if (err) {
      showBusinessError(err);
      throw new CustomException(err, '获取已过期的消费券列表失败');
    }
    this.voucherList = sortExpiredList(res);
  }
  private toDetail(item: VoucherItem) {
    biHT('wallet.cvlist.listpage.cv_click', {
      fcvid: item.cvId,
    });
    setCardCache(item, this.isInvalidCouponPage);
    this.$router.push({
      name: 'voucherDetail',
    });
  }
}
